import { render, staticRenderFns } from "./CatNicknameDialogBase.vue?vue&type=template&id=29c8af72&scoped=true"
import script from "./CatNicknameDialogBase.vue?vue&type=script&lang=ts"
export * from "./CatNicknameDialogBase.vue?vue&type=script&lang=ts"
import style0 from "./CatNicknameDialogBase.vue?vue&type=style&index=0&id=29c8af72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c8af72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29c8af72')) {
      api.createRecord('29c8af72', component.options)
    } else {
      api.reload('29c8af72', component.options)
    }
    module.hot.accept("./CatNicknameDialogBase.vue?vue&type=template&id=29c8af72&scoped=true", function () {
      api.rerender('29c8af72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/CatNicknameDialogBase.vue"
export default component.exports